// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__2FLGZ","boxTitle":"Qualiphy_boxTitle__1B3GQ","box":"Qualiphy_box__2u4LA","toggleWrap":"Qualiphy_toggleWrap__1pPXy"};